import React, {useState, useEffect} from 'react';
import '../css/App.css';
import '../css/bootstrap.min.css';
import Snooze from './Snooze';
import Comments from './Comments';
import NotificationInfo from './NotificationInfo';
import bootstrap from 'bootstrap';
import AlertWindow from '../Alert';


class NotificationRow extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      snooze: false,
      comments: false,
      notificationInfo: false,
      linkNotCliked:true,
      alertWindow:""
    };
    this.completeTask = this.completeTask.bind(this);
    this.openComments = this.openComments.bind(this);
    this.openSnooze = this.openSnooze.bind(this);
    this.openDetails = this.openDetails.bind(this);
  }
  
  componentDidMount(){
  }
  
  completeTask = async () => {
    
    //If this task have a link it requires the user to click on it
    //in order to finish the task
    if(this.props.link != "" && this.state.linkNotCliked){
      this.setState({alertWindow:"You need to click on the link in other to complete this task"});
      return;
    }

    let formdata = new FormData();
    formdata.append("id", this.props.id);
    formdata.append("user", this.props.user);

    let requestOptions = {
      method: 'POST',
      body: formdata,
      redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/notifications/completenotification.php", requestOptions)
    .then(response => response.text())
    .then(result => {
      this.props.deleteNotification(this.props.i);
    })
    .catch(error => console.log('error', error));

  }

  closeAlertWindow = () =>{
    this.setState({alertWindow:""})
  }

  openNotification = (e) =>{
   console.log(e.target.nodeName);
  }

  unlockTask = () =>{
   this.setState({linkNotCliked:false})
  }

  openSnooze = () =>{
    const showSnooze = this.state.snooze;
    if(!showSnooze){
      this.setState({snooze:true});
    }else{
      this.props.refreshAll();
      this.setState({snooze:false});
    }
  }

  openDetails = () =>{
    const showDetails = this.state.notificationInfo;
    if(!showDetails){
      this.setState({notificationInfo:true});
    }else{
      this.setState({notificationInfo:false});
    }
  }

  openComments = () =>{
    const showComments = this.state.comments;
    if(!showComments){
      this.setState({comments:true});
    }else{
      this.setState({comments:false});
    }
  }

  render() {

    let windowAlertHTML;
    if(this.state.alertWindow != ""){
      windowAlertHTML = 
      <AlertWindow 
        title="I am sorry..." 
        message={this.state.alertWindow} 
        close={this.closeAlertWindow}
      />
    }

    let linkButton;
    if(this.props.link != ""){
      linkButton = <a href={this.props.link} target='_blank'><button onClick={this.unlockTask} type="button" className="mx-2">Link</button></a>
    }

    let snoozer;
    if(this.state.snooze){
      snoozer = <Snooze close={this.openSnooze} id={this.props.userNotificationId} refresh={this.props.refresh}/>
    }

    let comments;
    if(this.state.comments){
      comments = <Comments close={this.openComments} id={this.props.userNotificationId} user={this.props.user}/>
    }

    let notificationColorPriority;
    if(this.props.priority < 5){
      //Low priority CSS Class
      notificationColorPriority = 'notification-row'
    }else if(this.props.priority < 8){
      //Medium priority CSS Class
      notificationColorPriority = 'notification-row-med'
    }else{
      //High priority CSS Class
      notificationColorPriority = 'notification-row-high'
    }

    let notificationInfo;
    if(this.state.notificationInfo){
      notificationInfo =

      <NotificationInfo
        id={this.props.id}
        commentsId = {this.props.userNotificationId}
        user={this.props.user}
        generatedBy={this.props.generatedBy}
        seenDate={this.props.seenDate}
        date={this.props.date}
        priority={this.props.priority}
        text={this.props.text}
        snoozeCount={this.props.snoozeCount}
        close={this.openDetails}
      />
        
    }

    return(
      <tr onDoubleClick={this.openDetails} className={notificationColorPriority}>
          {comments}
          {snoozer}
          {notificationInfo}
          {windowAlertHTML}
        <td>{this.props.priority}</td>
        <td>{this.props.text}</td>
        <td>{this.props.date}</td>
        <td>
          <div className="btn-group" role="group" aria-label="Basic example">
            <button onClick={this.openComments} type="button" className="mx-2">Comments</button>
            <button onClick={this.openSnooze} type="button" className="mx-2">Snooze</button>
            <button onClick={this.completeTask} type="button" className="mx-2">Complete Task</button>
            {linkButton}
          </div>
        </td>
      </tr>    
    );
  }
}

export default NotificationRow;